import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Slide } from '@mui/material'
import useScrollTrigger from '@mui/material/useScrollTrigger'
import { setMenuBarIsHidden } from '../../store/configuration/configurationSlice'

interface SliderProps {
  children: React.ReactElement
}

const HideOnScroll = ({ children }: SliderProps) => {
  const dispatch = useDispatch()
  const trigger = useScrollTrigger()

  useEffect(() => {
    dispatch(setMenuBarIsHidden(trigger))
  }, [trigger])

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  )
}

export default HideOnScroll
